import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { v4 as uuid4 } from 'uuid'

import { BuilderMenu } from '@makyoapp/makyo-common/dist/builder'
import { Plus16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant, Modal, ModalGridFooter } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { genIdent } from '@/shared/utils'

import MenuListItem from './MenuListItem'

const MENU_TYPES = [
  {
    id: 'read-only',
    label: 'Read Only',
    description: 'Suitable for menu items that use read only actions such as view, open URL, navigate, etc.',
  },
  {
    id: 'read-write',
    label: 'Read & Write',
    description: 'Suitable for menu items that use both read and write actions such as update, delete, duplicate, etc.',
  },
]

function MenuPanelNormal() {
  const { t } = useTranslation()
  const { menus = [], isMenuLoading, addMenu } = useAppBuilderContext()

  const [showCreateMenuModal, setShowCreateMenuModal] = useState(false)

  const [selectedMenuType, setSelectedMenuType] = useState<string>(MENU_TYPES[0].id)

  // todo: add menu type after SDK support
  const handleCreateMenu = async () => {
    const newMenu: BuilderMenu = {
      id: uuid4(),
      title: genIdent(menus as unknown as Record<string, unknown>[], 'title', menus.length + 1, 'Menu '),
      items: [],
    }

    await addMenu(newMenu)
    setShowCreateMenuModal(false)
  }

  return (
    <div className='p-4'>
      <div className={clsx('menu-list flex flex-col pb-4')}>
        <div className='uppercase py-2'>
          <Trans>Menus</Trans>
        </div>
        <div className='flex flex-col gap-1'>
          {menus.map((menu) => {
            return <MenuListItem menu={menu} key={menu.id} />
          })}
        </div>
      </div>

      <Button icon={<Plus16 />} onClick={() => setShowCreateMenuModal(true)} className='w-full'>
        <Trans>New Menu</Trans>
      </Button>

      <Modal show={showCreateMenuModal} onHide={() => setShowCreateMenuModal(false)}>
        <Modal.Header onCloseClick={() => setShowCreateMenuModal(false)}>
          <Trans>Create New Menu</Trans>
        </Modal.Header>

        <Modal.Body className='modal-md'>
          <div className='px-2 py-4'>
            <Trans>{`Choose menu type:`}</Trans>

            <div className='mt-4 flex gap-2'>
              {MENU_TYPES.map((type) => {
                const isSelected = selectedMenuType === type.id
                return (
                  <Button
                    key={type.id}
                    variant={isSelected ? ButtonVariant.Normal : ButtonVariant.Ghost}
                    onClick={() => setSelectedMenuType(type.id)}
                    className='!rounded-full'
                  >
                    {type.label}
                  </Button>
                )
              })}
            </div>

            <div className='mt-6 p-4 border bdr'>
              <div className=''>{MENU_TYPES.find((type) => type.id === selectedMenuType)?.description}</div>
            </div>
          </div>
        </Modal.Body>

        <ModalGridFooter
          cancelLabel={t('Cancel')}
          onCancel={() => setShowCreateMenuModal(false)}
          onHide={() => setShowCreateMenuModal(false)}
          onSubmit={handleCreateMenu}
          isLoading={isMenuLoading}
          primaryLabel={t('Create')}
        />
      </Modal>
    </div>
  )
}
export default MenuPanelNormal
